import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { LogOut, Shield, Home as HomeIcon } from 'lucide-react';

interface AdminHeaderProps {
  onLogout: () => void;
}

const AdminHeader = ({ onLogout }: AdminHeaderProps) => {
  return (
    <nav className="bg-gradient-to-r from-slate-900 to-slate-800 shadow-lg border-b border-slate-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center space-x-3 rtl:space-x-reverse">
            <Shield className="h-8 w-8 text-emerald-400" />
            <div className="text-right">
              <span className="text-2xl font-bold text-white">لوحة الإدارة</span>
              <p className="text-sm text-slate-300">منصة كنف العقارية</p>
            </div>
          </div>
          <div className="flex items-center space-x-4 rtl:space-x-reverse">
            <Button 
              onClick={onLogout} 
              variant="outline" 
              className="bg-red-600 border-red-600 text-white hover:bg-red-700 hover:border-red-700"
            >
              <LogOut className="h-4 w-4 mr-2" />
              تسجيل الخروج
            </Button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default AdminHeader;